// --- smooth scroll --------------
 
// lenis smooth scroll
const lenis = new Lenis({
  smoothWheel: true, // Smooth wheel behavior
  smoothTouch: false, // Disable smooth touch scrolling (if needed)
  normalizeWheel: true, // Normalize wheel events
  // Ignore elements with the class 'scroll-section' (or any other class you use)
  ignore: (el) => el.classList.contains("scroll-section"),
});
 
lenis.on("scroll", ScrollTrigger.update);
gsap.ticker.add((time) => {
  lenis.raf(time * 700);
});
 
gsap.ticker.lagSmoothing(0);
 
// --- smooth scroll --------------



document.addEventListener("DOMContentLoaded", function () {
  const menuBtn = document.querySelector(".mobile li p");
  const popup = document.querySelector(".menupopup");
  const closeBtn = document.querySelector(".menupopup_close");
  const wrapper = document.querySelector(".menupopup_wrapper");

  // open / toggle menu
  menuBtn.addEventListener("click", function (e) {
    e.stopPropagation();
    popup.classList.toggle("active");
  });

  // close on close icon click
  if (closeBtn) {
    closeBtn.addEventListener("click", function (e) {
      e.stopPropagation();
      popup.classList.remove("active");
    });
  }

  // close when clicking outside wrapper
  popup.addEventListener("click", function () {
    popup.classList.remove("active");
  });

  // prevent closing when clicking inside content
  wrapper.addEventListener("click", function (e) {
    e.stopPropagation();
  });
});



// ---------- MOUSE SCROLL-X ----------

function enableLeftClickDragScroll(container) {
    if (!container)
        return;
    let isDragging = !1
      , dragStarted = !1
      , startX = 0
      , scrollStart = 0;
    const dragThreshold = 5;
    container.addEventListener("mousedown", e => {
        e.button === 0 && (isDragging = !0,
        dragStarted = !1,
        startX = e.pageX,
        scrollStart = container.scrollLeft,
        container.classList.add("is-dragging"),
        e.preventDefault())
    }
    ),
    container.addEventListener("mousemove", e => {
        if (!isDragging)
            return;
        const deltaX = e.pageX - startX;
        !dragStarted && Math.abs(deltaX) > dragThreshold && (dragStarted = !0),
        dragStarted && (container.scrollLeft = scrollStart - deltaX)
    }
    ),
    container.addEventListener("mouseup", () => {
        isDragging = !1,
        container.classList.remove("is-dragging")
    }
    ),
    container.addEventListener("mouseleave", () => {
        isDragging = !1,
        container.classList.remove("is-dragging")
    }
    ),
    container.addEventListener("click", e => {
        dragStarted && (e.preventDefault(),
        e.stopPropagation(),
        dragStarted = !1)
    }
    ),
    container.classList.add("is-draggable")
}
function waitForElementAndInit(selector) {
    document.querySelectorAll(selector).forEach(el => {
        el._dragInitialized || (enableLeftClickDragScroll(el),
        el._dragInitialized = !0)
    }
    ),
    new MutationObserver(mutations => {
        for (const mutation of mutations)
            mutation.addedNodes.forEach(node => {
                node instanceof HTMLElement && (node.matches(selector) && !node._dragInitialized && (enableLeftClickDragScroll(node),
                node._dragInitialized = !0),
                node.querySelectorAll?.(selector)?.forEach(el => {
                    el._dragInitialized || (enableLeftClickDragScroll(el),
                    el._dragInitialized = !0)
                }
                ))
            }
            )
    }
    ).observe(document.body, {
        childList: !0,
        subtree: !0
    })
}
document.addEventListener("DOMContentLoaded", () => {
    [".pdp2-vid-main",".pdp2-review-main",".ingredients-list"].forEach(selector => {
        waitForElementAndInit(selector)
    }
    )
}
);

// ---------- MOUSE SCROLL-X ----------





// accodian
    (function () {
        const accordionItemHeaders = document.querySelectorAll('.pdp-accordion .accordion-item-header');

        accordionItemHeaders.forEach((accordionItemHeader) => {
        accordionItemHeader.addEventListener('click', function () {
            const currentlyActive = document.querySelector('.pdp-accordion .accordion-item-header.active');

            if (currentlyActive && currentlyActive !== this) {
            currentlyActive.classList.remove('active');
            currentlyActive.nextElementSibling.style.maxHeight = 0;
            }

            this.classList.toggle('active');
            const accordionItemBody = this.nextElementSibling;
            accordionItemBody.style.maxHeight = this.classList.contains('active')
            ? accordionItemBody.scrollHeight + 'px'
            : 0;
        });
        });

        // 👉 Open the first item by default
        const firstHeader = accordionItemHeaders[0];
        if (firstHeader) {
        firstHeader.classList.add('active');
        const firstBody = firstHeader.nextElementSibling;
        firstBody.style.maxHeight = firstBody.scrollHeight + 'px';
        }
    })();
// accodian


// =================================== for dots ========================




function snapScrollLeft(el){
    const mediaWrapper = el.closest(".card__inner");
    const dotsWrapper = mediaWrapper.querySelector(".card-img-dots");
    const galleryWrapper = mediaWrapper.querySelector(".card-img-ul");
    
    const imgCount = dotsWrapper.querySelectorAll("li").length;
    const galleryWidth = galleryWrapper.scrollWidth;
    const scrollAmount = galleryWidth / imgCount;
    
    galleryWrapper.scrollBy({ 
        left: -scrollAmount, 
        behavior: "smooth" 
    });
    
    const current = dotsWrapper.querySelector("li.active");
    const previous = current.previousElementSibling;
    const previoustoPrev = previous ? previous.previousElementSibling : null;
    const next = el.nextElementSibling;

    if (previous) {
        current.classList.remove("active");
        previous.classList.add("active");
    }
    
    if(next){
        next.style.opacity = "1";
    }
    
    if(!previoustoPrev){
        el.style.opacity = "0";
    }
}


function snapScrollRight(el){
    const mediaWrapper = el.closest(".card__inner");
    const dotsWrapper = mediaWrapper.querySelector(".card-img-dots");
    const galleryWrapper = mediaWrapper.querySelector(".card-img-ul");
    
    const imgCount = dotsWrapper.querySelectorAll("li").length;
    const galleryWidth = galleryWrapper.scrollWidth;
    const scrollAmount = galleryWidth / imgCount;
    
    galleryWrapper.scrollBy({ 
        left: scrollAmount, 
        behavior: "smooth" 
    });
    
    const current = dotsWrapper.querySelector("li.active");
    const prev = el.previousElementSibling;
    const next = current.nextElementSibling;
    const nexttoNext = next ? next.nextElementSibling : null;
    
    if (next) {
        current.classList.remove("active");
        next.classList.add("active");
    }
    
    if(prev){
        prev.style.opacity = "1";
    }
    
    if(!nexttoNext){
        el.style.opacity = "0";
    }
}



// -------------------------------------------
// iOS-SAFE REPLACEMENT FOR THE "scrollend" EVENT
// -------------------------------------------

function onScrollEnd(element, callback, delay = 120) {
    let timeout;
    element.addEventListener("scroll", () => {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            callback();
        }, delay);
    });
}



// ---------------------
// DOTS + BUTTON SYNCING
// ---------------------

function connectDotsChange(){
    const Cardcontainer = document.querySelectorAll('.card-img-ul');
    
    Cardcontainer.forEach(card => {
        const cardWrapper = card.closest(".card");
        const cardDots = cardWrapper.querySelector(".card-img-dots");
        const items = card.querySelectorAll('.card-img-ul li');
        
        // REPLACED scrollend → onScrollEnd
        onScrollEnd(card, () => {
            const liWid = card.clientWidth;
            const snapLi = Math.round(card.scrollLeft / liWid) + 1;
            
            // Update dots
            cardDots.querySelector("li.active")?.classList.remove("active");
            cardDots
            .querySelector(`li[data-val='${snapLi}']`)
            ?.classList.add("active");
            
            // Left button visibility
            const leftBtn = cardWrapper.querySelector('.ci-left-btn');
            leftBtn.style.opacity = snapLi === 1 ? "0" : "1";
            
            // Right button visibility
            const rightBtn = cardWrapper.querySelector('.ci-right-btn');
            rightBtn.style.opacity = snapLi === items.length ? "0" : "1";
        });
    });
}



// ---------------------
// OBSERVER FOR DYNAMIC CONTENT
// ---------------------

function setCardDots(elTag){
    new MutationObserver(() => {
        connectDotsChange();
    }).observe(elTag, {
        childList: true,
        subtree: true,
    });
}



// ---------------------
// INITIALIZATION
// ---------------------

document.addEventListener("DOMContentLoaded", () => {
    connectDotsChange();
    
    if (location.pathname.includes("/collections/")) {
        const filtData = document.querySelector('aside');
        if (filtData) setCardDots(filtData);
    }
    
    if (location.pathname.includes("/products/")) {
        const filtData = document.querySelector('product-recommendations');
        if (filtData) setCardDots(filtData);
    }
});

//================================= for dots ============================================= 